import React from 'react';
import ReactDOM from 'react-dom/client';
import { ToastContainer, toast } from 'react-toastify';

import { ThemeProvider } from '@emotion/react';
import { CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import 'react-toastify/dist/ReactToastify.css';
import 'leaflet/dist/leaflet.css';
import './index.css';
import './utils/logger';
import 'moment/locale/tr';

import { theme } from './theme/theme';
import MainContianer from './container/MainContainer';
import tr from 'date-fns/locale/tr';
import './utils/logger';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <ThemeProvider theme={theme}>
    <LocalizationProvider adapterLocale={tr} dateAdapter={AdapterDateFns}>
      <CssBaseline />
      <MainContianer />
      <ToastContainer newestOnTop />
    </LocalizationProvider>
  </ThemeProvider>,
  // </React.StrictMode>,
);
